module.exports = __webpack_public_path__ + "img/arrow-right.1a032fd1.svg";